import { Injectable } from '@angular/core';
import { TokenAuthService } from './token-auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermanentPlanService {

 constructor(public tokenAuthService: TokenAuthService,
    private httpClient: HttpClient,
  ) { }


    readonly permanentPlan_URL = `${environment.base_URL}${environment.permanentPlan_URL}`;
  
    getPermanentPlans(): Observable<any> {
          const url = `${this.permanentPlan_URL}`;
  
      // Retrieve the token from the tokenAuthService
      return this.tokenAuthService.getToken().pipe(
        switchMap((token) => {
          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
          });
  
          return this.httpClient.get<any[]>(url, { headers });
        }),
        catchError((error) => {
          throw error;
        })
      );
    }

    submitPermanentPlanForApproval(permanentPlanDto: any): Observable<any> {
      const url = `${this.permanentPlan_URL}`;
  
      // Retrieve the token from the tokenAuthService
      return this.tokenAuthService.getToken().pipe(
        switchMap((token) => {
          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
          });
  
          return this.httpClient.post<any[]>(url, permanentPlanDto, { headers });
        }),
        catchError((error) => {
          throw error;
        })
      );
    }

    getPermanentPlanPendingApprovals(): Observable<any> {
      const url = `${this.permanentPlan_URL}/pending`;
  
      // Retrieve the token from the tokenAuthService
      return this.tokenAuthService.getToken().pipe(
        switchMap((token) => {
          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
          });
  
          return this.httpClient.get<any[]>(url, { headers });
        }),
        catchError((error) => {
          throw error;
        })
      );
    }

    viewPermanentPlanById(planId: any): Observable<any> {
      const url = `${this.permanentPlan_URL}/pending/${planId}`;
  
      // Retrieve the token from the tokenAuthService
      return this.tokenAuthService.getToken().pipe(
        switchMap((token) => {
          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
          });
  
          return this.httpClient.get<any>(url, { headers });
        }),
        catchError((error) => {
          throw error;
        })
      );
    }

     approvePermanentPlan(planId: any): Observable<any> {
      const url = `${this.permanentPlan_URL}/approve/${planId}`;
  
      // Retrieve the token from the tokenAuthService
      return this.tokenAuthService.getToken().pipe(
        switchMap((token) => {
          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
          });
  
          return this.httpClient.post<any>(url, {}, { headers });
        }),
        catchError((error) => {
          throw error;
        })
      );
    }

    rejectPermanentPlan(planId: any): Observable<any> {
      const url = `${this.permanentPlan_URL}/reject/${planId}`;
  
      // Retrieve the token from the tokenAuthService
      return this.tokenAuthService.getToken().pipe(
        switchMap((token) => {
          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
          });
  
          return this.httpClient.post<any>(url, {}, { headers });
        }),
        catchError((error) => {
          throw error;
        })
      );
    }

    updatePermanentPlan(planId: any, permanentPlanDto: any): Observable<any> {
      const url = `${this.permanentPlan_URL}/${planId}`;
  
      // Retrieve the token from the tokenAuthService
      return this.tokenAuthService.getToken().pipe(
        switchMap((token) => {
          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
          });
  
          return this.httpClient.put<any>(url, permanentPlanDto, { headers });
        }),
        catchError((error) => {
          throw error;
        })
      );
    }

    deletePermanentPlan(planId: any): Observable<any> {
      const url = `${this.permanentPlan_URL}/${planId}`;
  
      // Retrieve the token from the tokenAuthService
      return this.tokenAuthService.getToken().pipe(
        switchMap((token) => {
          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
          });
  
          return this.httpClient.delete<any>(url, { headers });
        }),
        catchError((error) => {
          throw error;
        })
      );
    }
  
}
